/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-restricted-syntax */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ComponentStripsChart from './ComponentStripsChart';
import StripChartTable from './stripChartTable';
import { StripChartSectionProps, TubeData } from '../types';
import { RootState } from '../../../redux/rootState';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';

function StripChartSection({ showTable, data }:StripChartSectionProps) {
  const { reportPdfResponse1, reportPdfResponse3, tableContent } = useSelector((state: RootState) => state.reportPdfSliceReducer);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { Calibration_Table } = reportPdfResponse3;

  const reorderedData = useMemo(() => data.map((it) => {
    if (it?.IsMultiOffset) {
      const calibrationCharts = it.Charts.filter((chart) => chart.IsCalibrationChart);
      const calChartsA = calibrationCharts.filter((chart) => chart.Section === '1');
      const calChartsB = calibrationCharts.filter((chart) => chart.Section === '2');
      const calChartsC = calibrationCharts.filter((chart) => chart.Section === '3');
      const nonCalibrationCharts = it.Charts.filter((chart) => !chart.IsCalibrationChart);
      const nonCalChartsA = nonCalibrationCharts.filter((chart) => chart.Section === '1');
      const nonCalChartsB = nonCalibrationCharts.filter((chart) => chart.Section === '2');
      const nonCalChartsC = nonCalibrationCharts.filter((chart) => chart.Section === '3');
      // const sortedCharts = [...nonCalibrationCharts].sort(
      //   (a, b) => Number(a.Section) - Number(b.Section),
      // );
      return { ...it, Charts: [...calChartsA, ...nonCalChartsA, ...calChartsB, ...nonCalChartsB, ...calChartsC, ...nonCalChartsC] };
    }
    return it;
  }), [data]);

  return (
    <>
      {
      reorderedData?.map((item, dIndex) => (
        <>
          {dIndex > 0 && <div className="page-break" />}
          <div className="p30" key={item?.Charts?.[0]?.Id}>
            <div className="pageHeader">
              <div className="topHeader">
                {ReportPart1(tableContent, CombineReportEnum.COMBINE_STRIP_CHARTS, PDFReportEnum.PDF_STRIP_CHARTS, 'Strip Charts')}
                <br />
                Test Instrument Used - Highline Automation
                {/* <div>Test Instrument Used Highline Automation, EC14</div> */}
                <div />
                <div>{`S/N ${reportPdfResponse1?.JobOrderData?.SerialNumber}`}</div>
              </div>
              <div className="underlineHeadingText textCenter">{item?.Charts?.[0]?.IsCalibrationChart ? 'Calibration Page' : 'Strip Chart'}</div>
              {/* {showTable && (
                // Map through Calibration_Table to find all matching entries
                // eslint-disable-next-line max-len
                  Calibration_Table?.filter((calibration: TubeData) => calibration.JobOrder === item[0]?.JobOrder).map((calibrationData: TubeData, index: number) => (
                  <>
                    <StripChartTable
                    // eslint-disable-next-line react/no-array-index-key
                      key={index} // Ensure a unique key for each StripChartTable
                      calibrationTableData={calibrationData}
                    />
                  </>
                ))
              )} */}
              {showTable && (
              // Map through Calibration_Table to find all matching entries
                Calibration_Table?.filter(
                  (calibration: TubeData) => calibration.JobOrder === item?.JobOrder
                    && calibration.VesselName === item?.VesselName,
                ).map((calibrationData: TubeData, index: number) => (
                  <>
                    <StripChartTable
                       // eslint-disable-next-line react/no-array-index-key
                      key={index} // Ensure a unique key for each StripChartTable
                      calibrationTableData={calibrationData}
                    />
                  </>
                ))
              )}
            </div>
          </div>
          <>
            {item?.Charts?.map((details, index) => (
              <div key={details.Id}>
                {(index > 0) && <div className="page-break" />}
                <ComponentStripsChart newDetails={details} showSn={index > 0} isMulti={item?.IsMultiOffset} />
              </div>
            ))}
          </>
        </>
      ))
    }
    </>
  );
}

export default StripChartSection;
